import React, { useState } from 'react';
import { useSessionStorage } from 'react-use';
import styled, { css } from 'styled-components';
import { Link, useParams } from 'wouter';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { LabelValue } from '../../../platform/types/LabelValue';
import { Button, Colors, Input } from '../../../ui';
import { MenuButton } from '../../../ui/MenuButton';
import { Shadows } from '../../../ui/Standards';
import { useResolve } from '../../Container';
import { TeamMemberStrip } from '../../account/TeamMemberStrip';
import { useOnTeamCreateFolder } from '../../actions/WorkspaceActions';
import { SortMode } from '../../common/Sorter';
import { SortModeSelector } from '../../workspace/SortModeSelector';
import { WorkspaceModel } from '../Models';
import { Flexer } from '../elements/LayoutElements';
import { FolderListView } from './FolderListView';
import { FolderTopView } from './FolderTopView';
import { MainBoardListView } from './MainBoardListView';

const sortOptions = [
    LabelValue('Last Visited', 'lastSeenAt'),
    LabelValue('Last Updated', 'updatedAt'),
    LabelValue('Date Created', 'createdAt'),
    LabelValue('Alphabetical', 'label'),
];

const Frame = styled.div`
    position: relative;
    border-radius: .5rem;
    padding: 1.5rem;
    /* box-shadow: ${Shadows.sm}; */
    border: solid 1px ${Colors.borderLight};
    background: white;
`;

const PathPart = styled.div<{ link?: boolean }>`
    max-width: 25vw;
    font-weight: 480;
    font-size: 1.625rem;
    padding: .25rem .375rem;
    color: ${Colors.text};
    border-radius: .25rem;
    pointer-events: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${p => p.link && css`
        pointer-events: all;

        &:hover {
            background: ${Colors.hover};
        }
        &:active {
            background: ${Colors.active};
        }
        cursor: pointer;
    `}
`;

export const TeamBoardsBrowser = () => {

    const input = useParams<{ folder?: string }>();

    const workspace = useObserver(useResolve(WorkspaceModel));
    const folder = workspace.folders.find(x => x.id === input.folder);

    const [search, setSearch] = useState('');
    const [sort, setSort] = useSessionStorage(`deqo/ui/${workspace.id}/boards/sort`, ['updatedAt', 'desc'] as SortMode);

    const params = {
        workspaceId: workspace.id,
        folderId: !search?.trim() ? (folder?.id || 'root') : null,
        search: search?.trim() || '',
        sort,
    };

    const onCreateFolder = useOnTeamCreateFolder(workspace.id);

    // if ((workspace.boards.length + workspace.folders.length) === 0) {
    //     return <BoardsEmpty />;
    // }

    return <Frame>
        {/* <XmasTinsel /> */}
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer flex="row" align="center" gap="1.5">
                <Flexer flex="row" align="center" margin="0 -.375">
                    <Link to={`~/${workspace.id}/boards`} onClick={() => setSearch('')}>
                        <PathPart link={!!folder || !!search}>{workspace.label}</PathPart>
                    </Link>
                    {(!!folder || !!search) && <PathPart>{'/'}</PathPart>}
                    {!!folder && !search && <PathPart>{folder.label}</PathPart>}
                    {!!search && <PathPart>Search</PathPart>}
                </Flexer>
            </Flexer>
            <TeamMemberStrip />
        </Flexer>
        <Flexer height="1" />
        <Flexer flex="row" align="center" justify="space-between">
            <Flexer>
                {!folder && !search &&
                    <>
                        <Button size="md" onAction={onCreateFolder}>New Folder</Button>
                    </>
                }
            </Flexer>
            <Flexer flex="row" align="center" gap="1">
                <Flexer data-tour="ab-search" width="16">
                    <Input autoFocus placeholder="Search" value={search} onChange={setSearch} />
                </Flexer>
                <Flexer width="9">
                    {!search && <SortModeSelector options={sortOptions} value={sort} onChange={setSort} />}
                    {!!search && <MenuButton block label="Relevance" disabled></MenuButton>}
                </Flexer>
            </Flexer>
        </Flexer>
        <Flexer height="2" />
        {!search && <>
            {!folder && <FolderListView {...params} />}
            {!!folder && <FolderTopView {...params} />}
        </>}
        <MainBoardListView {...params} />
    </Frame>;
};
